import { SuperLink as Link } from "@/components/common/super-link";
const intro = (
  <p>
    Kalkulatory medyczne to narzędzia przeznaczone dla lekarzy, które pomagają
    ocenić stan kliniczny pacjenta. Ocena możliwa jest dzięki wbudowanym
    algorytmom, które wykorzystują różne parametry takie jak: płeć, masę ciała
    czy wyniki badań laboratoryjnych. Algorytmy pomagają zaklasyfikować pacjenta
    do odpowiedniej grupy chorych, co ułatwia podjęcie decyzji o dalszej ścieżce
    terapeutycznej. Dostęp do kalkulatorów medycznych Remedium można uzyskać za
    pośrednictwem urządzenia mobilnego czy dowolnej przeglądarki komputerowej,
    dzięki czemu narzędzia te są zawsze dostępne pod ręką praktykującego
    lekarza. Razem z{" "}
    <a
      href="https://remedium.md/wyszukiwarka-lekow/"
      target="_blank"
      rel="noreferrer"
    >
      Wyszukiwarką Leków
    </a>{" "}
    i{" "}
    <a href="https://remedium.md/icd10/" target="_blank" rel="noreferrer">
      Wyszukiwarką ICD-10
    </a>
    , Kalkulatory medyczne stanowią użyteczne aplikacje dla profesjonalistów
    medycznych każdej specjalizacji i praktykujących w dowolnej jednostce
    leczniczej, od sal szpitala przez oddziały ratunkowe i intensywnej terapii
    po przychodnie i gabinety lekarskie.
  </p>
);

const content = (
  <>
    {" "}
    <h3>Kalkulatory eGFR</h3>
    <p>
      Wskaźnik filtracji kłębuszkowej (<strong>GFR</strong>, ang. glomerular
      filtration rate) jest pomocny przy ocenie funkcji nerek pacjenta. W
      praktyce klinicznej jest to możliwe dzięki{" "}
      <strong>kalkulatorowi eGFR</strong> , który pozwala na obliczenie
      szacowanego wskaźnika filtracji kłębuszkowej (
      <em>ang. estimated glomerular filtration rate</em>). W zależności od
      znajomości poszczególnych parametrów pacjenta, można skorzystać z narzędzi
      wykorzystujących następujące wzory:
    </p>
    <ul>
      <li>
        <a
          href="https://remedium.md/kalkulatory/nefrologia-urologia/wzor-cockroft-gault"
          target="_blank"
          rel="noreferrer"
        >
          Cockrofta i Gaulta
        </a>{" "}
        - w oparciu o płeć, wiek, masę ciała pacjenta oraz stężenie kreatyniny w
        surowicy;
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/nefrologia-urologia/wskaznik-egfr"
          target="_blank"
          rel="noreferrer"
        >
          CKD-EPI - oprócz płci i wieku pacjenta, w zależności od formuły,
          konieczna jest znajomość stężenia kreatyniny w surowicy i/lub
          cystatyny C w surowicy;
        </a>
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/antestezjologia-i-intensywna-terapia/mdrd-filtracja-klebuszkowa-wzor-uproszczony"
          target="_blank"
          rel="noreferrer"
        >
          MDRD
        </a>{" "}
        - uproszczony wzór, który pozwala na oszacowanie wskaźnika filtracji
        kłębuszkowej bez znajomości masy ciała;
      </li>
      <li>
        w przypadku pacjentów pediatrycznych, konieczne jest{" "}
        <strong>
          obliczenie wskaźnika eGFR z wykorzystaniem wzoru Schwartza
        </strong>
        .
      </li>
    </ul>
    <p>
      Otrzymany wynik można zakwalifikować do jednego z pięciu stadiów nasilenia{" "}
      <strong>niewydolności nerek</strong>, co pozwala na podjęcie odpowiednich
      dla danego pacjenta decyzji terapeutycznych.
    </p>
    <h3>Kalkulator dawek leków</h3>
    <p>
      Kalkulator dawek leków to narzędzie znajdujące zastosowanie przede
      wszystkim wśród lekarzy pediatrów, internistów, lekarzy POZ i lekarzy
      medycyny ratunkowej. <strong>Przeliczanie dawek leków</strong> w populacji
      pediatrycznej wykorzystywane jest w celu dobrania ilości substancji
      czynnej odpowiedniej do wieku i masy ciała pacjenta. Przeliczane są na
      przykład antybiotyki (
      <a
        href="https://remedium.md/wyszukiwarka-lekow/substancje-czynne/amoxicillin-68"
        target="_blank"
        rel="noreferrer"
      >
        amoksycylina
      </a>
      ) czy leki przeciwbólowe (
      <a
        href="https://remedium.md/wyszukiwarka-lekow/substancje-czynne/ibuprofen-606"
        target="_blank"
        rel="noreferrer"
      >
        ibuprom
      </a>
      ,
      <a
        href="https://remedium.md/wyszukiwarka-lekow/substancje-czynne/paracetamol-917"
        target="_blank"
        rel="noreferrer"
      >
        paracetamol
      </a>
      ).
      <strong>Obliczanie dawek leków</strong> stosowane jest także w sytuacjach
      zagrożenia życia przy podaży leków dożylnie. Substancje czynne, takie jak
      epinefryna, alteplaza czy insulina, wymagają dobrania dawki odpowiednio
      wysokiej, aby pacjent mógł być skutecznie leczony i odpowiednio niskiej,
      aby możliwe działania niepożądane nie pogorszyły stanu pacjenta.{" "}
      <strong>Kalkulator dawkowania leku</strong> znajduje zastosowanie również
      u pacjentów internistycznych, przyjmujących leki o wąskim indeksie
      terapeutycznym (np.{" "}
      <a
        href="https://remedium.md/wyszukiwarka-lekow/substancje-czynne/azathioprine-106"
        target="_blank"
        rel="noreferrer"
      >
        azatiopryna
      </a>
      ) lub tych, u których dawka leku musi zostać zredukowana z powodu
      współistniejącej choroby nerek.
    </p>
    <h3>Kalkulator BMI</h3>
    <p>
      <strong>Kalkulator BMI</strong> jest prostym narzędziem wykorzystywanym
      zarówno przez pracowników ochrony zdrowia, jak i pacjentów. W celu
      oszacowania, czy masa ciała pacjenta jest prawidłowa w stosunku do
      wzrostu, należy wyliczyć <strong>wskaźnik BMI</strong> (
      <em>ang. Body Mass Index</em>). BMI w zależności od uzyskanego wyniku może
      wskazywać na niedożywienie, prawidłową masę ciała, nadwagę lub otyłość.{" "}
      <strong>Obliczenie BMI</strong> polega na podzieleniu masy ciała (w
      kilogramach) przez wzrost podniesiony do kwadratu (w metrach). Należy
      pamiętać, że <strong>kalkulator BMI</strong> nie bierze pod uwagę takich
      parametrów jak proporcje tkanki mięśniowej i tłuszczowej w organizmie, czy
      też poziom aktywności fizycznej, przez co uzyskany wyniki może nie
      odzwierciedlać faktycznego stanu odżywienia pacjenta.
    </p>
    <h3>Popularne kalkulatory wykorzystywane w praktyce lekarskiej</h3>
    <p>
      Do dyspozycji lekarza pozostaje znaczna liczba kalkulatorów medycznych
      utworzona przez specjalistów pracujących w różnych dziedzinach medycyny.
      Poniżej przedstawiamy nasze najpopularniejsze kalkulatory medyczne:
    </p>
    <ul>
      <li>
        <a
          href="https://remedium.md/kalkulatory/kardiologia/skala-cha2ds2%E2%80%93vasc"
          target="_blank"
          rel="noreferrer"
        >
          Skala CHA₂DS₂-VASc
        </a>{" "}
        – <strong>skalę CHADSVASc</strong> nazwano od pierwszych liter
        parametrów w niej uwzględnionych.
        <strong> Skala CHADSVASc</strong> ocenia ryzyko wystąpienia powikłań
        zakrzepowo-zatorowych u chorych z migotaniem przedsionków (
        <strong>AF</strong> –<em>ang. atrial fibrillation</em>);
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/neurologia/skala-glasgow-ocena-poziomu-swiadomosci"
          target="_blank"
          rel="noreferrer"
        >
          Glasgow Coma Scale (GCS)
        </a>{" "}
        – <strong>kalkulator skali Glasgow</strong> wykorzystywany jest w ocenie
        przytomności pacjenta. Ocenia zdolność otwierania oczu, nawiązywanie
        kontaktu słownego i obecność reakcji ruchowej u pacjenta;
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/hepatologia/fib-4"
          target="_blank"
          rel="noreferrer"
        >
          Wskaźnik FIB-4
        </a>
        – <strong>kalkulator FIB 4</strong> ocenia prawdopodobieństwo
        zwłóknienia wątroby u pacjentów znajdujących się w grupie ryzyka
        niealkoholowej stłuszczeniowej choroby wątroby, w skrócie NAFLD (
        <em>ang. non-alcoholic fatty liver disease</em>);
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/kardiologia/SCORE2"
          target="_blank"
          rel="noreferrer"
        >
          Wskaźniki SCORE2 i SCORE2-OP
        </a>{" "}
        – <strong>kalkulator SCORE</strong> umożliwia oszacowanie 10-letniego
        ryzyka wystąpienia incydentów sercowo-naczyniowych u pacjentów;
        wariantem SCORE jest <strong>SCORE OP kalkulator</strong> , który został
        skalibrowany pod kątem pacjentów powyżej 70 roku życia;
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/kardiologia/pol-score-2015"
          target="_blank"
          rel="noreferrer"
        >
          Skala POL-SCORE 2015
        </a>{" "}
        – podobnie jak <strong>kalkulator SCORE, POL-SCORE</strong> umożliwia
        oszacowanie 10-letniego ryzyka wystąpienia incydentów
        sercowo-naczyniowych, przy czym <strong>POL-SCORE</strong> jest
        wariantem skalibrowanym do populacji polskiej;
      </li>
      <li>
        <a
          href="https://remedium.md/kalkulatory/pulmonologia/wskaznik-crb-65"
          target="_blank"
          rel="noreferrer"
        >
          Skala CRB-65
        </a>{" "}
        – skala <strong>CRB 65</strong> wykorzystywana jest do prognozowania
        ryzyka zgonu u pacjentów z pozaszpitalnym zapaleniem płuc.
      </li>
    </ul>
    <p>
      Szerzej na temat narzędzi przydatnych w codziennej praktyce lekarskiej,
      takich jak np. kalkulatory medyczne, pisaliśmy w naszym e-booku{" "}
      <a
        href="https://remedium.md/ebook/pierwsze-kroki-w-poz"
        target="_blank"
        rel="noreferrer"
      >
        Pierwsze kroki w POZ (Edycja 2022)
      </a>
      , dostępnym do pobrania bezpłatnie.
    </p>
    <p>
      Każdy z kalkulatorów medycznych posiada funkcję dodania go do ulubionych.
      Dzięki temu najczęściej wykorzystywane kalkulatory zostaną dodane do
      Twojego konta, a dostęp do nich będzie widnieć na{" "}
      <Link href="/zapisane">stronie zapisanych zasobów</Link>.
    </p>
  </>
);

export const calculatorDescription = { intro, content };
